























































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import AccountSearch from '@/app/components/Account/AccountSearch.vue'
import AccountListHeader from '@/app/components/Account/AccountListHeader.vue'
import AccountList from '@/app/components/Account/AccountList.vue'
/* api */
import AccountListApi from '@/app/model/api/accountListApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, userType, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    ErrorModal,
    AccountSearch,
    AccountListHeader,
    AccountList
  }
})
export default class Account extends Vue {
  private isOkAccountList: boolean = false
  private defaultAccountData: any[] = []
  private accountData: any = this.$store.state.accountState.accountData
  private count: number = 0
  private notDataMessage: boolean = false
  private showList: boolean = false
  private showLoading: boolean = true
  private complateMessage: string = this.$store.state.alertState.message

  created () {
    /* 検索結果を保持しているかどうか判定 */
    let stateData = this.$store.state.accountState
    if (stateData.choiceAccountType === 0 &&
        stateData.searchText === '') {
      this.getAccountList()
    } else {
      let data: any = {
        order_name: this.$store.state.accountState.sortName,
        sort: this.$store.state.accountState.sortAsc
      }
      this.doAccountSort(data)
    }
  }

  // trueなら検索保持あり、falseなら検索保持無し
  private getAccountList () {
    (async () => {
      /* 初期表示は名前の昇順 */
      let data = {
        type: 0, // すべてのユーザー
        text: '', // 空
        order_name: this.$store.state.accountState.sortName, // 名前で固定
        sort: this.$store.state.accountState.sortAsc
      }

      if (data.sort) {
        data.sort = 'asc'
      } else {
        data.sort = 'desc'
      }

      const result = await AccountListApi.getAccountList(data)

      if (result.isOk()) {
        this.accountData = result.getPayload().users
        this.count = this.accountData.length
        this.defaultAccountData = result.getPayload().users

        if (this.accountData.length === 0) {
          this.notDataMessage = true
        } else {
          this.notDataMessage = false
        }

        this.isOkAccountList = true
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private updateList (val: any) {
    this.$store.commit('accountState/setAccountList', val)
    this.accountData = this.$store.state.accountState.accountData

    if (this.accountData.length === 0) {
      this.notDataMessage = true
    } else {
      this.notDataMessage = false
    }

    this.showList = true
  }

  private resetList () {
    this.getAccountList()
  }

  /* 検索はソートリセット(初期値に戻す) */
  private doAccountSort (data: any = {
    // 名前の昇順が初期値
    order_name: 'name',
    sort: true
  }) {
    (async () => {
      this.showLoading = true
      /* state保持 */
      this.$store.commit('accountState/setSortName', data.order_name)
      this.$store.commit('accountState/setSortAsc', data.sort)

      if (data.sort) {
        data.sort = 'asc'
      } else {
        data.sort = 'desc'
      }

      /* 検索、ソート条件を含めてデータ作成 */
      let searchData: any = {
        type: this.$store.state.accountState.choiceAccountType,
        text: this.$store.state.accountState.searchText,
        order_name: data.order_name,
        sort: data.sort
      }

      const result = await AccountListApi.getAccountList(searchData)

      if (result.isOk()) {
        this.updateList(result.getPayload().users)
        this.accountData = result.getPayload().users
        this.count = this.accountData.length
        this.isOkAccountList = true
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private logout () {
    CommonClass.doLogout()
  }
}
